import { render, staticRenderFns } from "./turnOffModal.vue?vue&type=template&id=d42e3ec6&"
import script from "./turnOffModal.vue?vue&type=script&lang=js&"
export * from "./turnOffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports